import React from "react";
import HeaderPrint from "../components/HeaderPrint";
import "../styles/print.stye.css";
import SignaturePrint from "../components/SignaturePrint";
import CommentPrint from "../components/CommentPrint";
import RenderValue from "../components/RenderValue";
import { formatDateToThai } from "../../../../../utils/date.utils";
import { thaiMonths } from "../../../../../utils/monthThai";

const Form04 = ({
  header,
  sub_header,
  title,
  send_to,
  data,
  dataReportDetail,
  dataEmployee,
}: {
  header: string;
  sub_header: string;
  title: string;
  send_to: string;
  data: any;
  dataReportDetail: any;
  dataEmployee: any;
}) => {

  const {
    day: ref_day,
    month: ref_month,
    year: ref_year,
  } = formatDateToThai(
    dataReportDetail
      ? dataReportDetail?.condition?.received_summons_date
      : null
  );

  const {
    day: start_leave_day,
    month: start_leave_month,
    year: start_leave_year,
  } = formatDateToThai(
    dataReportDetail
      ? dataReportDetail?.condition?.received_summons_since_date
      : null
  );

  return (
    <div>
      <HeaderPrint
        header={header}
        sub_header={sub_header}
        title={title}
        send_to={send_to}
        data={{
          title: "วิทยาลัยพุทธศาสนานานาชาติ",
          date: data.created_date,
        }}
      />
      {/* line 1 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ข้าพเจ้า"}
          end_label={null}
          length={90}
          value={dataEmployee?.first_name}
          isParagraph={true}
        />
        {/*  */}
        <RenderValue
          start_label={"ฉายา/นามสกุล"}
          end_label={null}
          length={90}
          value={dataEmployee?.last_name}
          isParagraph={false}
        />
      </div>
      {/* line 2 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ตำแหน่ง"}
          end_label={null}
          length={70}
          value={dataEmployee?.work_history?.position_name}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เลขที่"}
          end_label={null}
          length={45}
          value={dataEmployee?.employee_no}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"สังกัด"}
          end_label={null}
          length={30}
          value={"IBSC"}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"แผนงาน"}
          end_label={null}
          length={40}
          value={dataEmployee?.department?.department_name_th}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ได้รับหมายเรียกของ"}
          end_label={null}
          length={50}
          value={dataReportDetail?.condition?.received_summons}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ที่"}
          end_label={null}
          length={50}
          value={dataReportDetail?.condition?.received_summons_address}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ลงวันที"}
          end_label={null}
          length={10}
          value={ref_day}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={30}
          value={ref_month?.toString() ? thaiMonths[ref_month] : null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={20}
          value={ref_year}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ให้เข้ารับการ"}
          end_label={"ณ"}
          length={60}
          value={dataReportDetail?.condition?.received_summons_receive}
          isParagraph={false}
        />
        {/*  */}
        <span className="ml-4">
          <RenderValue
            start_label={"ที่"}
            end_label={null}
            length={150}
            value={dataReportDetail?.condition?.received_summons_place}
            isParagraph={false}
          />
        </span>
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ตั้งแต่วันที่"}
          end_label={null}
          length={15}
          value={start_leave_day ?? null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={40}
          value={
            start_leave_month?.toString() ? thaiMonths[start_leave_month] : null
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={20}
          value={start_leave_year ?? null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"มีกำหนด"}
          end_label={"วัน"}
          length={20}
          value={
            dataReportDetail?.condition?.received_summons_scheduled_date ?? null
          }
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content mt-8">
        {/*  */}
        <RenderValue
          start_label={"จึงรายงานมาเพื่อโปรดพิจารณาอนุมัติ"}
          end_label={null}
          length={0}
          value={null}
          isParagraph={true}
        />
      </div>

      {/* signature*/}
      <div className="w-full ml-24">
        <SignaturePrint
          title={"นมัสการมาด้วยความเคารพ"}
          prefix={`ลงชื่อ`}
          position={""}
          isDate={false}
          isPosition={false}
          data={{}}
        />
      </div>
      <div className="w-full">
        <CommentPrint
          title={"ความคิดเห็นของผู้บังคับบัญชาขั้นต้น"}
          isCheckBoxApprove={false}
          sxTitle=""
          amountLine={2}
          isParagraph={true}
          data={{
            isApprove: data.leave_status === "approve third" ? true : false,
            comment: data.leave_approve_first_comment ?? "",
          }}
          lengthDot={250}
        />
        <div className="ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>

        <CommentPrint
          title={"คำสัางของผู้มีอำนาตอนุญาต"}
          isCheckBoxApprove={true}
          sxTitle=""
          amountLine={2}
          isParagraph={true}
          data={{
            isApprove: data.leave_status === "approve third" ? true : false,
            comment: data.leave_approve_first_comment ?? "",
          }}
          lengthDot={250}
        />
        <div className="ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>
      </div>
    </div>
  );
};

export default Form04;
